import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Leftmenu from "../../components/Leftmenu";
import Rightmenu from "../../components/Rightmenu";
import Pagination from "../../components/Pagination";
import { Link, useOutletContext, useNavigate } from "react-router-dom";
import moment from "moment";

function AdminActivityLogs() {
  const { user, token } = useOutletContext();
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    from: 0,
    to: 0,
  });

  useEffect(() => {
    if (user && user.role !== "admin") {
      navigate("/");
      return;
    }
    fetchLogs(currentPage);
  }, [user, currentPage]);

  const fetchLogs = (page = 1) => {
    setLoading(true);
    fetch(`/api/admin/activity-logs?page=${page}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ page }),
    })
      .then((res) => res.json())
      .then((resData) => {
        setLoading(false);
        if (resData.data?.data) {
          setLogs(resData.data.data);
          setPagination({
            current_page: resData.data.current_page,
            last_page: resData.data.last_page,
            total: resData.data.total,
            from: resData.data.from,
            to: resData.data.to,
          });
        } else if (Array.isArray(resData.data)) {
          setLogs(resData.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching logs:", err);
        setLoading(false);
      });
  };

  const getActionBadgeClass = (action) => {
    if (action.includes("approved")) return "bg-success text-white";
    if (action.includes("banned") || action.includes("rejected")) return "bg-danger text-white";
    if (action.includes("deleted")) return "bg-secondary text-white";
    if (action.includes("created")) return "bg-primary text-white";
    return "bg-info text-white";
  };

  return (
    <div>
      <Header />
      <Leftmenu />
      <div className="main-content bg-lightblue theme-dark-bg admin-main-page" style={{ minHeight: "100vh" }}>
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left w-100" style={{ maxWidth: "100%", margin: 0, paddingRight: 0 }}>
            <div className="admin-wrap-full w-100" style={{ maxWidth: "100%", margin: 0 }}>
              {/* Header Card */}
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4 rounded-xxl overflow-hidden">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex align-items-center justify-content-between rounded-3">
                  <div className="d-flex align-items-center">
                    <Link to="/admin/dashboard" className="text-white me-3">
                      <i className="feather-arrow-left font-sm"></i>
                    </Link>
                    <div>
                      <h4 className="font-xs text-white fw-600 mb-0">System Activity Logs</h4>
                      <span className="font-xssss text-white opacity-75">Audit trail of admin and platform moderation actions</span>
                    </div>
                  </div>
                  <Link to="/admin/dashboard" className="btn btn-sm btn-light font-xssss fw-600 px-3 py-1 rounded-pill">
                    &larr; Dashboard
                  </Link>
                </div>
              </div>

              {/* Refresh & Filter Bar */}
              <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white mb-4">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="font-xssss fw-600 text-grey-600">
                    <i className="feather-shield text-danger me-1"></i> Recorded Moderation & Management Events
                  </span>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary font-xssss fw-600 px-3 py-2 rounded-xl"
                    onClick={() => fetchLogs(currentPage)}
                  >
                    <i className="feather-refresh-cw me-1"></i> Refresh Logs
                  </button>
                </div>
              </div>

              {/* Logs Table */}
              <div className="card shadow-xss border-0 p-4 rounded-xxl bg-white mb-4">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-danger" role="status"></div>
                    <p className="mt-3 text-grey-600 font-xsss mb-0">Loading activity logs...</p>
                  </div>
                ) : logs.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table align-middle table-hover mb-0 font-xssss">
                        <thead className="bg-light">
                          <tr>
                            <th className="py-3 ps-3">Timestamp</th>
                            <th className="py-3">Action</th>
                            <th className="py-3">Details</th>
                            <th className="py-3 pe-3 text-end">Actor</th>
                          </tr>
                        </thead>
                        <tbody>
                          {logs.map((log) => (
                            <tr key={log.id} className="border-bottom">
                              <td className="ps-3 py-3" style={{ minWidth: 150 }}>
                                <span className="fw-600 text-grey-800 d-block">{moment(log.created_at).format("lll")}</span>
                                <small className="text-grey-400 font-xsssss">{moment(log.created_at).fromNow()}</small>
                              </td>
                              <td>
                                <span className={`badge font-xsssss text-uppercase px-2 py-1 rounded-pill ${getActionBadgeClass(log.action)}`}>
                                  {log.action.replace(/_/g, " ")}
                                </span>
                              </td>
                              <td className="py-3">
                                <p className="font-xsss fw-500 text-grey-900 mb-0">{log.description}</p>
                              </td>
                              <td className="pe-3 text-end">
                                <span className="fw-700 text-grey-800 d-block">{log.user?.name || "System"}</span>
                                <small className="badge bg-light text-dark font-xsssss text-uppercase px-2 py-0 border">
                                  {log.user?.role || "system"}
                                </small>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <Pagination
                      currentPage={pagination.current_page}
                      lastPage={pagination.last_page}
                      total={pagination.total}
                      from={pagination.from}
                      to={pagination.to}
                      onPageChange={(p) => setCurrentPage(p)}
                      itemName="logs"
                    />
                  </>
                ) : (
                  <div className="text-center py-5">
                    <i className="feather-activity font-xxl text-grey-400 mb-2 d-block"></i>
                    <h5 className="fw-700 font-xs text-grey-800 mb-1">No Activity Logs Found</h5>
                    <p className="text-grey-500 font-xssss mb-0">System events will appear here as accounts and posts are moderated.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminActivityLogs;
